export const calculateAge = (birthdate) => {
    if (!birthdate) return '';

    const today = new Date();
    const birthDate = new Date(birthdate);

    if (Number.isNaN(birthDate.getTime())) return '';

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age.toString();
};

export const isDateInFuture = (dateStr) => {
    if (!dateStr) return false;

    const noteDate = new Date(dateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    noteDate.setHours(0, 0, 0, 0);

    return noteDate > today;
};

export const isDateToday = (dateStr) => {
    if (!dateStr) return false;

    const parts = dateStr.split('-').map(Number);
    if (parts.length !== 3) return false;

    const [year, month, day] = parts;
    const noteDate = new Date(year, month - 1, day);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    noteDate.setHours(0, 0, 0, 0);

    return noteDate.getTime() === today.getTime();
};
